import type { RouteObject } from 'react-router';
import { tenantNav } from '@/lib/nav/tenant';
import { collectRoutes } from '../routes';

const modules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', { eager: true });

export const tenantRoutes = collectRoutes(modules, tenantNav, '/tenant');
